const EventNames = 
{
    DevelopmentOfAgriculture: "Development Of Agriculture",
    DevelopmentOfCivilization: "Development Of Civilization",
    DevelopmentOfCrafts: "Development Of Crafts",
    DevelopmentOfMarkets: "Development Of Markets",
    DevelopmentOfPlanning:" Development Of Planning",
    DevelopmentOfPolitics: "Development Of Politics",
    DevelopmentOfReligion: "Development Of Religion",
    DevelopmentOfScience: "Development Of Science",
    DevelopmentOfSettlement: "Development Of Settlement",
    DevelopmentOfTradeRoutes: "Development Of Trade Routes",
    DevelopmentOfWarfare: "Development Of Warfare",
    Barbarians: "Barbarians",
    BorderConflict: "Border Conflict",
    CallToArms: "Call to Arms",
    Crusades: "Crusades",
    CulturalInfluence: "Cultural Influence",
    DarkAges: "Dark Ages",
    Foray: "Foray",
    GoodHarvest: "Good Harvest",
    Immigration: "Immigration",
    KnowledgeOfTheAncients: "Knowledge of the Ancients",
    NewDeposits: "New Deposits",
    Pestilence: "Pestilence",
    Raiders: "Raiders",
    Rats: "Rats",
    Rebellion: "Rebellion",
    ReignOfTerror: "Reign Of Terror",
    ScientificBreakthrough: "Scientific Breakthrough",
    UncertainBorders: "Uncertain Borders",
    ArmsIndustry: "Arms Industry",
    CivilUnrest: "Civil Unrest",
    ColdWar: "Cold War",
    CrimeWave: "Crime Wave",
    EconomicProgress: "Economic Progress",
    Emigration: "Emigration",
    FreedomOfMovement: "Freedom of Movement",
    Iconoclasm: "Iconoclasm",
    IndependenceDeclaration: "Independence Declaration",
    InternationalAgreement: "International Agreement",
    InternationalNegotiations: "International Negotiations",
    NationalPride: "National Pride",
    PoliticsOfStrength: "Politics of Strength",
    PopularizationOfScience: "Popularization of Science",
    Prosperity: "Prosperity",
    RavagesOfTime: "Ravages of Time",
    Refugees: "Refugees",
    Terrorism: "Terrorism",
    ImpactOfAgriculture: "Impact of Agriculture",
    ImpactOfArchitecture: "Impact of Architecture",
    ImpactOfBalance: "Impact of Balance",
    ImpactOfColonies: "Impact of Colonies",
    ImpactOfCompetition: "Impact of Competition",
    ImpactOfCulture: "Impact of Culture",
    ImpactOfGovernment: "Impact of Government",
    ImpactOfHappiness: "Impact of Happiness",
    ImpactOfHarmony: "Impact of Harmony",
    ImpactOfIndustry: "Impact of Industry",
    ImpactOfPopulation: "Impact of Population",
    ImpactOfProgress: "Impact of Progress",
    ImpactOfScience: "Impact of Science",
    ImpactOfStrength: "Impact of Strength",
    ImpactOfTechnology: "Impact of Technology",
    ImpactOfVariety: "Impact of Variety",
    ImpactOfWonders: "Impact of Wonders",
}

module.exports = EventNames